// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__G3VK5","gfeWrapper":"CalendarEvent_gfeWrapper__3Jz9C"};